@if (data && informations) {
  <div>
    <app-form
      [informations]="informations"
      [helptexts]="helptexts"
      [data]="data"
      (dataSubmitted)="onData($event)"
    ></app-form>
    @if (error) {
      <div>
        <mat-error>{{ error }}</mat-error>
      </div>
    }
  </div>
}
